import React from "react";
import Slider from "react-slick";
//
import { FlexDiv } from "../../../components/Atoms";
//
import {
  CardWrapper,
  TestimonialContainer,
  Wrapper,
  SlickWrapper,
  HeadingWrapper,
  Title,
  StyledImage,
  Description,
  Heading,
} from "./style";
//
const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        arrows: true,
      },
    },
  ],
};
//
function FeaturesSection({ data = {}, arrowImage = "arrow-solid.svg" }) {
  const { title: heading, features } = data;

  return (
    <Wrapper>
      <TestimonialContainer>
        <HeadingWrapper>
          <FlexDiv flexDirection={"column"}>
            <Heading variant="heading4" my={2}>
              {heading}
            </Heading>
          </FlexDiv>
        </HeadingWrapper>
        <SlickWrapper maxWidth="100%" arrowImage={arrowImage}>
          <Slider {...settings}>
            {features?.map(({ title, subTitle, image }, index) => {
              return (
                <CardWrapper key={index}>
                  <StyledImage src={image} />
                  <Title variant="label2">{title}</Title>
                  <Description variant="paragraph3">{subTitle}</Description>
                </CardWrapper>
              );
            })}
          </Slider>
        </SlickWrapper>
      </TestimonialContainer>
    </Wrapper>
  );
}

export default FeaturesSection;
